export default "__VITE_ASSET__CyGuvDV$__$_?url__"